import axios from "axios";
import { call, put, takeLatest,takeEvery  } from "redux-saga/effects";
import {
    CREATE_INVENTORY_ADJUSTMENT,
    UPDATE_FTL_RECEIVE,
    LIST_ALL_INVENTORY,
    LIST_INVENTORY_ADJUSTMENT_TYPES,
    LIST_INVENTORY_ENTRIES,
    LIST_MANUFACTURERS,
    UPDATE_INVENTORY_THRESHOLD,
    RECALCLATE_RUNNING_RATES,
    LIST_ALL_BOX_INVENTORY,
    GET_INVENTORY_SUMMARY_FOR_FTL,
    LIST_ALL_PRODUCT_INVENTORY,
    LIST_INVENTORY_ALERTS,
    LIST_ALL_AISLE,
    SAVE_AISLE,
    GET_LATEST_SHORTCODE_LOCATIONS,
    CONFIRM_INVENTORY_COUNT,
    GET_ALL_PRODUCT_INVENTORY,
} from '../../constants/inventory';
import {DAMAGE, INVENTORY} from "../../../components/global/Server/endpoints";
import {
    clearInventoryEntries,
    getLatestShortcodesByLocation,
    listAllBoxInventory,
    listAllProductInventory,
    listInventoryAlerts, setRunRateCalculating,
    storeAllAisle,
    storeAllBoxInventory,
    storeAllDamages,
    storeAllInventory,
    storeAllProductInventory, storeAllShortcodeInventory,
    storeInventoryAdjustmentTypes,
    storeInventoryAlerts,
    storeInventoryEntries,
    storeInventorySummaryForFTL,
    storeLatestShortcodesByLocation,
    storeManufacturers,
    storePoInformation,
    storeSupplierByPoNumber,
    storeUpdatedInventoryItem,

} from '../../actions/inventory';
import {
    hideError,
    requestStatus,
    setInventoryEntriesLoadingStatus,
    setLoadingStatus,
    showErrorMessage
} from "../../actions/global";
import { fetchAlerts } from "../../actions/alerts";
import { HTTP_SUCCESS } from "../../constants/global";
import { SERVER_FAILED_ERROR_MESSAGE } from "../../../pages/Dashboard/DashboardFinal/constants";


const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        "Authorization": `Bearer ${token}`
    }
}

const postRequest = (endpoint, data) => {
    return axios.post(endpoint, data, {
        headers: getHeaders()
    })
        .then(response => response)
}

const getRequest = (endpoint) => {
    return axios.get(endpoint, {
        headers: getHeaders()
    })
        .then(response => response);
}



function* listAllInventorySaga() {
    yield put(setLoadingStatus(true))
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(INVENTORY.LIST_ALL_INVENTORY));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeAllInventory(response.data));
        yield put(requestStatus(status));
    } catch (error) {
        yield put(setLoadingStatus(false))
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
    yield put(setLoadingStatus(false))
}

function* listInventoryAdjustmentTypesSaga() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(INVENTORY.LIST_INVENTORY_ADJUSTMENT_TYPES));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeInventoryAdjustmentTypes(response.data));
        yield put(requestStatus(status));
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listManufacturersSaga() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(INVENTORY.LIST_MANUFACTURERS));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeManufacturers(response.data));
        yield put(requestStatus(status));
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listInventoryAlertsSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(INVENTORY.LIST_INVENTORY_ALERTS, {updateAlerts: action.updateAlerts, fetchAlertsData: action.fetchAlertsData}));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeInventoryAlerts(response.data));
        yield put(requestStatus(status));
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listBoxesInventorySaga(action) {
    yield put(setLoadingStatus(true))
    try {
        const response = yield call(() => postRequest(INVENTORY.LIST_BOXES_INVENTORY, action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeAllBoxInventory(response.data));
        yield put(requestStatus(status));
    } catch (error) {
    } finally {
        yield put(setLoadingStatus(false))
    }
}

function* getInventorySummaryForFTL(action) {
    yield put(setLoadingStatus(true))
    try {
        const response = yield call(() => postRequest(INVENTORY.GET_INVENTORY_SUMMARY_FOR_FTL, action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeInventorySummaryForFTL(response.data, action.meta.columnId));
        yield put(requestStatus(status));
        if (typeof action.callback === 'function') {
            action.callback();
        }
    } catch (error) {
    } finally {
        yield put(setLoadingStatus(false))
    }
}

function* listProductsInventorySaga(action) {
    yield put(setLoadingStatus(true))
    try {
        const response = yield call(() => postRequest(INVENTORY.LIST_PRODUCTS_INVENTORY, action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeAllProductInventory(response.data));
        yield put(requestStatus(status));
    } catch (error) {
    } finally {
        yield put(setLoadingStatus(false))
    }
}



///////


function* createInventoryAdjustmentSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(INVENTORY.CREATE_INVENTORY_ADJUSTMENT, action.inventoryAdjustment));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };

        if (response.data.success) {
            yield put(fetchAlerts(action.data))
            yield put(storeInventoryEntries(response.data.inventoryEntries));
            action.isProducts ?
                yield put(listAllProductInventory(action.selectedLocationData))
                : yield put(listAllBoxInventory(action.selectedLocationData));
        } else {
            yield put(showErrorMessage(response.data.message))
        }
        yield put(requestStatus(status));
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

//////////////////////

function* listInventoryEntriesSaga(action) {
    yield put(hideError())
    yield put(setInventoryEntriesLoadingStatus(true))
    try {
        if(action.data.dateChanged){
            yield put(clearInventoryEntries())
        }
        const response = yield call(() => postRequest(INVENTORY.LIST_INVENTORY_ENTRIES, action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeInventoryEntries(response.data));
        yield put(requestStatus(status));
    } catch (error) {
        yield put(setInventoryEntriesLoadingStatus(false))
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
    yield put(setInventoryEntriesLoadingStatus(false))
}
///

function* updateInventoryThresholdSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(INVENTORY.UPDATE_INVENTORY_THRESHOLD, action.inventoryItem));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (response.data.success) {
            yield put(storeUpdatedInventoryItem(response.data.inventory));
            yield put(listInventoryAlerts( true, action.data))
        } else {
            yield put(showErrorMessage(response.data.message))
        }

        yield put(requestStatus(status));
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* recalculateRunningRatesSaga(action) {
    yield put(hideError())
    yield put(setRunRateCalculating(true))
    yield put(setLoadingStatus(true))
    try {
        const response = yield call(() => getRequest(INVENTORY.RECALCULATE_RUNNING_RATES));
        if(response.status == 200){
            action.callback()
        }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
    yield put(setRunRateCalculating(false))
    yield put(setLoadingStatus(false))
}


function* updateFTLReceiveSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(INVENTORY.UPDATE_FTL_RECEIVE, { transferId: action.transferId, fromDate: action.fromDate, toDate:action.toDate }));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (response.data.success) {
            yield put(fetchAlerts(action.data));
            yield put(storeInventoryEntries(response.data.inventoryEntries));
            action.isProducts ?
                yield put(listAllProductInventory(action.selectedLocationData))
                : yield put(listAllBoxInventory(action.selectedLocationData));
        } else {
            yield put(showErrorMessage(response.data.message))
        }

        yield put(requestStatus(status));
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* listAllAisleSaga(action) {
    yield put(setLoadingStatus(true))
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(INVENTORY.LIST_ALL_AISLE,action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeAllAisle(response.data.aisle));
        yield put(requestStatus(status));
    } catch (error) {
        yield put(setLoadingStatus(false))
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
    yield put(setLoadingStatus(false))
}

function* saveAisleSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(INVENTORY.SAVE_AISLE, action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (response.data.success) {
           yield put(storeAllAisle(response.data.aisle));
        } else {
            yield put(showErrorMessage(response.data.message))
        }

        yield put(requestStatus(status));
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* getShortcodesByLocationForLatestDateSaga(action) {
    yield put(setLoadingStatus(true))
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(INVENTORY.GET_LATEST_SHORTCODE_LOCATION,action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeLatestShortcodesByLocation(response.data));
        yield put(requestStatus(status));
    } catch (error) {
        yield put(setLoadingStatus(false))
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
    yield put(setLoadingStatus(false))
}

function* confirmInventoryCountSaga(action) {
    yield put(setLoadingStatus(true))
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(INVENTORY.CONFIRM_INVENTORY_COUNT,action.data));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
         yield action.reset()
        yield put(requestStatus(status));
    } catch (error) {
        yield put(setLoadingStatus(false))
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
    yield put(setLoadingStatus(false))
}

function* getAllProductsInventorySaga() {
    try {
        const response = yield call(() => getRequest(INVENTORY.GET_ALL_PRODUCTS_INVENTORY));
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeAllShortcodeInventory(response.data));
        yield put(requestStatus(status));
    } catch (error) {
      yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

export default function* inventorySagas() {
    yield takeLatest(LIST_ALL_INVENTORY, listAllInventorySaga);
    yield takeLatest(LIST_INVENTORY_ADJUSTMENT_TYPES, listInventoryAdjustmentTypesSaga);
    yield takeLatest(LIST_MANUFACTURERS, listManufacturersSaga);
    yield takeLatest(LIST_INVENTORY_ALERTS, listInventoryAlertsSaga);
    yield takeLatest(LIST_ALL_BOX_INVENTORY, listBoxesInventorySaga);
    yield takeEvery(GET_INVENTORY_SUMMARY_FOR_FTL, getInventorySummaryForFTL);
    yield takeLatest(LIST_ALL_PRODUCT_INVENTORY, listProductsInventorySaga);

    yield takeLatest(CREATE_INVENTORY_ADJUSTMENT, createInventoryAdjustmentSaga);
    yield takeLatest(UPDATE_FTL_RECEIVE, updateFTLReceiveSaga);

    yield takeLatest(LIST_INVENTORY_ENTRIES, listInventoryEntriesSaga);

    yield takeLatest(UPDATE_INVENTORY_THRESHOLD, updateInventoryThresholdSaga);
    yield takeLatest(LIST_ALL_AISLE, listAllAisleSaga);
    yield takeLatest(SAVE_AISLE, saveAisleSaga);
    yield takeLatest(GET_LATEST_SHORTCODE_LOCATIONS, getShortcodesByLocationForLatestDateSaga);
     yield takeLatest(CONFIRM_INVENTORY_COUNT, confirmInventoryCountSaga);
    yield takeLatest(RECALCLATE_RUNNING_RATES, recalculateRunningRatesSaga);
    yield takeLatest(GET_ALL_PRODUCT_INVENTORY, getAllProductsInventorySaga);

}